import reducer from './reducers';

import * as vendorActions from './actions';
import * as vendorTypes from './types';

export { vendorActions, vendorTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/vendor/index.js